export default __webpack_public_path__ + "static/media/ans_icon.a99a8fcb.svg";